import {changePosition} from "../../../../store/api";

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addNewCategory } from '../../../../store/api';
import { editMenu } from '../../../../store/Menu/api';

export const useChangeCategoriesPosition = ({ slug }) => {
    const queryClient = useQueryClient();

    return useMutation(['change-categories-position', slug], ({ items }) => changePosition(items), {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['menu-categories', slug]);
        },
    });
};
